<template>
    <div class="account-header"><!--  class="container" -->
            <slot name="left" v-if="hasLeft">
                <button class="btn btn-back" @click="back">
                    <img src="@/assets/img/icon_back.svg" alt="뒤로가기">
                </button>
            </slot>
            <h1 class="mb-0">{{title}}</h1>
            <!-- <slot name="right"> -->
                <router-link to="/" class="i-home">
                    <svg aria-label="홈으로" width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.916 19.804H3.917a1.068 1.068 0 0 1-1.071-1.066v-8.524H.703L10.658.312a1.074 1.074 0 0 1 1.516 0l9.956 9.902h-2.143v8.524c0 .589-.48 1.066-1.071 1.066zm-9.642-2.131h8.57V8.965l-6.428-6.393-6.428 6.393v8.708h4.286z" fill="#333"/>
                    </svg>
                </router-link>
            <!-- </slot> -->
        </div>
</template>

<script>
export default {
    props: {
        hasLeft: { type: Boolean, default: true },
        title: { type: String, default: '예스콘' },
    },
    
    methods: {
        back: function() {
            this.$router.back();
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/account.scss';
.account-header {
    // background: rgb(103,23,205);
    // background: linear-gradient(90deg, rgba(103,23,205,1) 0%, rgba(23,109,225,1) 100%);
    display: flex;
    height: calc(var(--header-height) - 5px); // 제플린 기준 - 공통헤더와 어카운트(유틸)헤더 height 차이 5px
    align-items: center;
    justify-content: space-between;
    color: #000;

    margin-bottom: 16px;

    .row {
        height: 60px;
        flex-wrap: nowrap;
    }
    .btn-back {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-right: 10px;
        width: 25px;
        height: 25px;
        font-size: 40px;
        line-height: 1;
        color: inherit;
    }
    h1 {
        font-size: var(--page-title-size);
        font-weight: 600;
        letter-spacing: -0.3px;
    }
    .btn-menu {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
        font-size: 30px;
        line-height: 1;
    }
    @media (min-width: 768px){

        height: auto;
        margin-bottom: 40px;

        .i-home{
            visibility: hidden;
        }
    }
}
</style>